let headTitle = "";

export function useHeadTitle(t: string) {
  if (t !== headTitle) {
    document.title = t;
    headTitle = t;
  }
}
